<div *ngIf="!loading" class="ks-confirmation ks-card">
  <header class="ks-card-header">
    <div class="ks-card-header__tools">
      <button
        type="button"
        ktTooltip="Close"
        class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
        (click)="cancel()"
      >
        <span inlineSVG="assets/icons/Close.svg"></span>
      </button>
    </div>
  </header>
  <main class="ks-card-body">
    <div
      *ngIf="data.iconPath"
      class="ks-dialog-icon ks-bg-lighter-{{ data.themeColor || 'neutral' }} ks-text-{{
        data.themeColor || 'neutral'
      }}"
    >
      <span [inlineSVG]="data.iconPath"></span>
    </div>
    <div class="ks-dialog-content" [innerHTML]="data.content | safe : 'html'"></div>
  </main>
  <footer class="ks-card-footer">
    <button type="button" class="ks-btn-sm ks-btn-outline-neutral" (click)="cancel()">
      {{ data.cancelLabel || 'Cancel' }}
    </button>
    <button
      type="button"
      class="ks-btn-sm ks-btn-{{ data.themeColor || 'neutral' }}"
      (click)="confirm()"
    >
      {{ data.confirmLabel || 'Confirm' }}
    </button>
  </footer>
</div>
